import { buttonRoundnessMultiplier } from "../../constants";
import { useAppTheme } from "../../useAppTheme";
import { useDevice } from "../../useDevice";
import Box from "../Box";
import { FlatCard } from "../Cards/FlatCard";
import { Skeleton } from "../Skeleton";

const TITLE_LINE_HEIGHT = 24;
const CHIP_HEIGHT = 28;
const CTA_HEIGHT = 38;
const LEADING_SIZE = 40;

type Props = {
	titleWidth?: `${number}%`;
};

const Chips = () => (
	<Box flexDirection="row" flexWrap="wrap" gap={4}>
		<Skeleton width={88} height={CHIP_HEIGHT} />
		<Skeleton width={64} height={CHIP_HEIGHT} />
	</Box>
);

const Title = ({ width }: { width: `${number}%` }) => (
	<Box height={TITLE_LINE_HEIGHT} justifyContent="center">
		<Skeleton width={width} height={16} />
	</Box>
);

export const PracticeTestListItemSkeleton = ({ titleWidth = "70%" }: Props) => {
	const { isMobile } = useDevice();
	const theme = useAppTheme();

	if (isMobile) {
		return (
			<Box
				backgroundColor={theme.colors.surface}
				padding={16}
				gap={8}
				borderBottomWidth={1}
				borderBottomColor={theme.colors.surfaceVariant}
			>
				<Box flexDirection="row" alignItems="center" gap={16}>
					<Skeleton size={LEADING_SIZE} variant="circle" />
					<Box flex={1} minWidth={0}>
						<Title width={titleWidth} />
					</Box>
				</Box>
				<Box
					flexDirection="row"
					alignItems="flex-end"
					justifyContent="space-between"
					gap={8}
				>
					<Box flex={1} minWidth={0} paddingBottom={6}>
						<Chips />
					</Box>
					<Skeleton
						width={112}
						height={CTA_HEIGHT}
						borderRadius={theme.roundness * buttonRoundnessMultiplier}
					/>
				</Box>
			</Box>
		);
	}

	return (
		<FlatCard style={{ overflow: "hidden" }}>
			<Box
				flexDirection="row"
				alignItems="center"
				justifyContent="space-between"
				gap={16}
				padding={16}
				minHeight={72}
			>
				<Skeleton size={LEADING_SIZE} variant="circle" />
				<Box flex={1} minWidth={0} gap={8} justifyContent="center">
					<Title width={titleWidth} />
					<Chips />
				</Box>
				<Skeleton
					width={128}
					height={CTA_HEIGHT}
					borderRadius={theme.roundness * buttonRoundnessMultiplier}
				/>
			</Box>
		</FlatCard>
	);
};
